<template>
    
    <div class="text-center">
      <!-- <v-container> -->
        <v-dialog v-model="showDialog" width="500" @click:outside="closeDialog" >
          <v-card class="elevation-0" :disabled="$store.getters.dialogLoader" v-if="item">

              <v-card-title class="primary lighten-2">                
                  Usuário
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
              </v-card-title>
              <v-card-text class="pt-10">
              
                <v-row v-if="item != null">
                
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.name"
                      :error-messages="$v.item.name && $v.item.name.$invalid ? ['Digite o nome'] : []"
                      label="Nome"
                      prepend-icon="mdi-lead-pencil"
                      maxlength="20"
                      clearable
                      outlined
                      dense
                      counter
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.lastName"
                      :error-messages="$v.item.name.$invalid ? ['Digite o sobrenome'] : []"
                      :disabled="$v.item.name.$invalid"
                      label="Nome do Plano"
                      prepend-icon="mdi-lead-pencil"
                      maxlength="20"
                      clearable
                      outlined
                      dense
                      counter
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="pt-0 pb-0">
                    <v-text-field
                      v-model="item.email"
                      :error-messages="$v.item.email.$invalid ? ['Digite um email válido'] : []"
                      :disabled="$v.item.lastName.$invalid"
                      label="Email"
                      prepend-icon="mdi-email"
                      maxlength="100"
                      clearable
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="pt-0 pb-0">
                    <v-select
                      :error-messages="$v.item.roles.$invalid ? ['Selecione um ou mais pefis'] : []"
                      :disabled="$v.item.email.$invalid"
                      v-model="item.roles"
                      :items="tipoList"
                      item-text="simpleName"
                      label="Perfis do usuário"
                      prepend-icon="mdi-account-group"
                      multiple
                      chips
                      hint="selecione um ou mais perfis"
                      persistent-hint
                      return-object
                      outlined
                    ></v-select>
                  </v-col>

                  <v-col cols="12" class="pt-8 pb-0 text-center body-1" v-if="errorMessage">
                    <span class="custom-error">{{errorMessage}}</span>
                  </v-col>

                </v-row>

              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="!item.id" :disabled="$v.item.$invalid" @click="saveNew">
                  Salvar
                  <v-icon right>mdi-cloud-upload</v-icon>
                </v-btn>
                <v-btn color="primary" v-if="item.id" @click="saveItem">
                  Atualizar
                  <v-icon right>mdi-cloud-upload</v-icon>
                </v-btn>
              </v-card-actions>

          </v-card>
        </v-dialog>
        
      <!-- </v-container> -->

      
    </div>

</template>

<script>

import HOST from '../ws';
import { required, minLength, email } from "vuelidate/lib/validators";
import SnackBar from '../snackbar'



export default {

  props : {
    item : Object,
    showDialog : Boolean, 
  },

  computed : {

  },

  data: () => ({

    myHost : HOST.HOST,
    errorMessage : null,

    tipoList : null,

  }),

  mounted() {

    this.errorMessage = null;
    const config = {
        headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
      };
      this.axios
      .post(this.myHost + '/user/allroles', {}, config)
      .then(response => {
        this.tipoList = response.data;
      });
      
  },

  

  methods : {

    closeDialog(){
      this.$emit('close-dialog', false);
    },

    
    saveItem() {

      this.$store.commit("setDialogLoader", true);
      
      this.axios({
        method: "post",
        url: this.myHost + "/user/save",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.currentToken}`
        },
        data: JSON.stringify(this.item)
      }).then(response => {
        console.log("salvando item: " + response.status);
        this.$store.commit("setDialogLoader", false);
        this.closeDialog();
        SnackBar.snackText = "Item salvo com sucesso";
        SnackBar.showSnack = true;
      });
    },

    saveNew() {

      this.$store.commit("setDialogLoader", true);
      
      this.axios({
        method: "post",
        url: this.myHost + "/user/savenew",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.currentToken}`
        },
        data: JSON.stringify(this.item)
      }).then(response => {
        console.log("salvando item: " + response.status);
        this.$store.commit("setDialogLoader", false);
        this.closeDialog();
        SnackBar.snackText = "Item salvo com sucesso";
        SnackBar.showSnack = true;
      });
    },
    

  },

  validations: {

    item: {
      name: {
        required,
        minLength: minLength(2)
      },
      lastName: {
        required,
      },
      email : {
        required,
        email,
      },
      roles: {
        required,
      },
      
    },
  }

};
</script>